export default __webpack_public_path__ + "static/media/blueloader.2a353e00.png";